export default "__VITE_ASSET__8zNhtWFBOfAe3WuL7mg5Ig__ 480w, __VITE_ASSET__Q4UDqKHMNbMzC1JLGzBzYg__ 768w, __VITE_ASSET__AsHNVVn_Y92mmWEtoBC9VA__ 1122w";